// extracted by mini-css-extract-plugin
export default {"control":"control_control__J6+HF","addIcon":"control_addIcon__-Z2sw"};